import api from '@/services/api'
import endpoints from '@/services/endpoints'
import {
  ChangePasswordPayload,
  LoginPayload,
  LoginResponse,
  PasswordResetPayload,
  PasswordResetResponse,
  SignupPayload,
  SignupResponse,
  User,
} from '@/types/auth'
import { AxiosRequestConfig } from 'axios'

const login = async (payload: LoginPayload): Promise<LoginResponse> => {
  const response = await api.post(endpoints.AUTH.LOGIN, payload)
  return response.data
}

const loginWith2Fa = async (payload: { token: string; code: string }): Promise<LoginResponse> => {
  const config: AxiosRequestConfig & { skipToastError?: boolean } = {
    skipToastError: true,
  }

  const response = await api.post(endpoints.AUTH.LOGIN_WITH_2FA, payload, config)
  return response.data
}

const resend2faCode = async (payload: { token: string }) => {
  const response = await api.post(endpoints.AUTH.RESEND_2FA_CODE, payload)
  return response.data
}

const getUserMe = async (): Promise<User> => {
  const response = await api.get(endpoints.AUTH.MYINFO)
  return response.data
}

const register = async (payload: SignupPayload): Promise<SignupResponse> => {
  const response = await api.post(endpoints.AUTH.REGISTER, payload)
  return response.data
}

const resetPassword = async (payload: PasswordResetPayload): Promise<PasswordResetResponse> => {
  const response = await api.post(endpoints.AUTH.PASSWORD_RESET, payload)
  return response.data
}

const checkPasswordResetLink = async (uid: string, token: string) => {
  const response = await api.get(endpoints.AUTH.CHECK_PASSWORD_RESET_LINK.replace(':uid', uid).replace(':token', token))
  return response.data
}

const confirmPasswordReset = async (
  uid: string,
  token: string,
  payload: { new_password1: string; new_password2: string },
) => {
  const response = await api.post(
    endpoints.AUTH.CHECK_PASSWORD_RESET_LINK.replace(':uid', uid).replace(':token', token),
    payload,
  )
  return response.data
}

const changePassword = async (payload: ChangePasswordPayload) => {
  const response = await api.patch(endpoints.AUTH.CHANGE_PASSWORD, payload)
  return response.data
}

const checkInvitation = async (token: string) => {
  const config: AxiosRequestConfig & { skipToastError?: boolean } = {
    skipToastError: true,
  }

  const response = await api.post(endpoints.AUTH.CHECK_INVITATION, { token }, config)
  return response.data
}

const acceptInvitation = async (token: string) => {
  const response = await api.post(endpoints.AUTH.ACCEPT_INVITATION, { token })
  return response.data
}

export default {
  login,
  loginWith2Fa,
  resend2faCode,
  getUserMe,
  register,
  resetPassword,
  checkPasswordResetLink,
  confirmPasswordReset,
  changePassword,
  checkInvitation,
  acceptInvitation,
}
